import { Link } from 'react-router-dom';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import Contact from '../home/components/Contact';
import WhatsAppDiagnostic from '../home/components/WhatsAppDiagnostic';

export default function RemplacementQuincaillerieFenetreLyon() {
  const services = [
    {
      icon: 'ri-door-lock-line',
      title: 'Poignées de Fenêtre',
      description: 'Remplacement de poignées cassées, bloquées ou usées. Tous modèles et finitions.',
      price: 'À partir de 45€'
    },
    {
      icon: 'ri-key-2-line',
      title: 'Crémones et Serrures',
      description: 'Réparation et remplacement de crémones, serrures multipoints et systèmes de verrouillage.',
      price: 'À partir de 80€'
    },
    {
      icon: 'ri-settings-4-line',
      title: 'Charnières et Paumelles',
      description: 'Remplacement de charnières usées, paumelles et compas pour fenêtres oscillo-battantes.',
      price: 'À partir de 60€'
    },
    {
      icon: 'ri-lock-password-line',
      title: 'Gâches et Verrous',
      description: 'Installation de gâches de sécurité, verrous et systèmes anti-effraction.',
      price: 'À partir de 50€'
    },
    {
      icon: 'ri-contrast-drop-line',
      title: 'Joints et Étanchéité',
      description: 'Remplacement de joints d\'étanchéité pour isolation optimale.',
      price: 'À partir de 40€'
    },
    {
      icon: 'ri-tools-fill',
      title: 'Réglage Complet',
      description: 'Ajustement et réglage de toute la quincaillerie pour un fonctionnement optimal.',
      price: 'À partir de 70€'
    }
  ];

  const brands = [
    { name: 'Ferco', specialty: 'Crémones et serrures' },
    { name: 'Roto', specialty: 'Oscillo-battant' },
    { name: 'Siegenia', specialty: 'Systèmes complets' },
    { name: 'GU', specialty: 'Sécurité renforcée' },
    { name: 'Winkhaus', specialty: 'Haute qualité' },
    { name: 'Maco', specialty: 'Innovation' }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-orange-600 via-orange-500 to-amber-500 pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <div className="max-w-3xl">
            <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-tools-line text-white"></i>
              <span className="text-white text-sm font-medium">Lyon - Expert Quincaillerie Fenêtre</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-extrabold text-white mb-6 leading-tight">
              Remplacement Quincaillerie Fenêtre Lyon
            </h1>
            
            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Spécialiste du remplacement de quincaillerie de fenêtre à Lyon. Poignées, crémones, charnières, serrures et tous mécanismes. Intervention rapide et pièces d'origine garanties.
            </p>
            
            <div className="flex flex-wrap gap-4">
              <a
                href="#contact"
                className="inline-flex items-center justify-center bg-white text-orange-600 px-8 py-4 rounded-full font-bold hover:bg-gray-50 transition-all shadow-lg whitespace-nowrap cursor-pointer"
              >
                Devis Gratuit
                <i className="ri-arrow-right-line ml-2"></i>
              </a>
              <a
                href="tel:0478XXXXXX"
                className="inline-flex items-center justify-center bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-full font-bold hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                Dépannage Rapide
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <span className="text-orange-600 font-semibold text-xs uppercase tracking-wider">
              NOS SERVICES
            </span>
            <h2 className="text-4xl lg:text-5xl font-extrabold text-gray-900 mt-3 mb-4">
              Remplacement Quincaillerie Fenêtre
            </h2>
            <p className="text-gray-600 text-lg max-w-3xl mx-auto">
              Solutions complètes pour tous vos problèmes de quincaillerie
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div className="w-14 h-14 bg-gradient-to-br from-orange-500 to-amber-400 rounded-full flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 text-sm mb-4 leading-relaxed">
                  {service.description}
                </p>
                
                <div className="pt-4 border-t border-gray-100">
                  <span className="text-orange-600 font-bold text-lg">{service.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Brands */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-extrabold text-gray-900 mb-4">
              Marques de Quincaillerie
            </h2>
            <p className="text-gray-600 text-lg">
              Nous travaillons avec les meilleures marques du marché
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {brands.map((brand, index) => (
              <div key={index} className="bg-orange-50 rounded-xl p-6 text-center hover:shadow-lg transition-all">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-3">
                  <span className="text-orange-600 font-bold text-lg">
                    {brand.name.substring(0, 2)}
                  </span>
                </div>
                <h3 className="text-sm font-bold text-gray-900 mb-1">
                  {brand.name}
                </h3>
                <p className="text-xs text-gray-600">
                  {brand.specialty}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <article className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-gray-900 mb-6">
              Expert Remplacement Quincaillerie Fenêtre Lyon
            </h2>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Spécialiste du <strong>remplacement de quincaillerie de fenêtre à Lyon</strong>, nous intervenons rapidement pour tous vos problèmes de mécanismes : poignées cassées, crémones défaillantes, charnières usées ou serrures bloquées. Notre stock important de pièces détachées nous permet d'intervenir efficacement sur toutes les marques.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Qu'est-ce que la Quincaillerie de Fenêtre ?
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-4">
              La quincaillerie de fenêtre désigne l'ensemble des mécanismes permettant l'ouverture, la fermeture et la sécurisation de vos fenêtres. Elle comprend les poignées, crémones, charnières, paumelles, gâches, verrous et tous les systèmes de verrouillage. Une quincaillerie de qualité garantit le bon fonctionnement et la sécurité de vos fenêtres pendant de nombreuses années.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Quand Remplacer la Quincaillerie ?
            </h3>
            
            <ul className="space-y-3 mb-6">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Poignée cassée ou bloquée :</strong> Remplacement immédiat pour retrouver l'usage de votre fenêtre</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Crémone défaillante :</strong> Problème de fermeture ou de verrouillage</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Charnières usées :</strong> Fenêtre qui frotte, difficultés d'ouverture</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Sécurité insuffisante :</strong> Mise à niveau avec quincaillerie anti-effraction</span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-orange-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700"><strong>Usure normale :</strong> Après 15-20 ans, remplacement préventif recommandé</span>
              </li>
            </ul>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Nos Marques Partenaires
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Nous travaillons exclusivement avec les meilleures marques de quincaillerie : <strong>Ferco</strong> (leader français), <strong>Roto</strong> (spécialiste oscillo-battant), <strong>Siegenia</strong> (innovation allemande), <strong>GU</strong> (sécurité renforcée), <strong>Winkhaus</strong> et <strong>Maco</strong>. Ces marques garantissent qualité, durabilité et disponibilité des pièces détachées.
            </p>

            <h3 className="text-2xl font-bold text-gray-900 mb-4 mt-8">
              Intervention Rapide à Lyon
            </h3>
            
            <p className="text-gray-700 leading-relaxed mb-6">
              Nous intervenons rapidement dans tout Lyon et sa région pour le remplacement de quincaillerie de fenêtre. Notre stock important nous permet de réparer la plupart des problèmes en une seule intervention. Devis gratuit et pièces d'origine garanties.
            </p>
          </article>
        </div>
      </section>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      {/* Contact */}
      <Contact />
      
      <Footer />
    </div>
  );
}
